import lucideIcons from "@dynamicImports/lucide-icons";
import { lazy, type ReactNode } from "react";

/**
 * Icons outside the preloaded set come from a lucide module that the server and the browser each load on their own.
 * Rendering waits for it on both, so the browser hydrates the icons the server rendered instead of empty places.
 */
const LucideIconsReady = lazy(async () => {
	// Without the module the page still renders, with empty icons that the browser renders again after hydration.
	await lucideIcons().catch(() => undefined);
	return { default: ({ children }: { children: ReactNode }) => <>{children}</> };
});

export default LucideIconsReady;
